import React, { ReactElement } from 'react';
import DividerAnt from 'antd/lib/divider';
import clsx from 'clsx';
import styles from './Divider.module.scss';

interface DividerProps {
    /**
     * @description Css class name.
     * @default undefined.
     */
    className?: string;
}

/**
 * @description Divider.
 * @param {DividerProps} props - Divider props.
 * @returns {ReactElement} - Divider.
 */
export const Divider: React.FC<DividerProps> = (props) => (
    <DividerAnt
        className={clsx(
            styles.divider,
            props.className ? props.className : null,
        )}
    />
);
